import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n";
import Landing from "./pages/Landing";
import Educacion from "./pages/Educacion";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ServicesOverview from "./pages/ServicesOverview";
import ServiceDetail from "./pages/ServiceDetail";
import Legal from "./pages/Legal";
import CookieBanner from "./components/CookieBanner";

function App() {
    return (
        <div className="App">
            <I18nProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/sectores/educacion" element={<Educacion />} />
                        <Route path="/servicios" element={<ServicesOverview />} />
                        <Route path="/servicios/:slug" element={<ServiceDetail />} />
                        <Route path="/privacidad" element={<Legal type="privacy" />} />
                        <Route path="/terminos" element={<Legal type="terms" />} />
                        <Route path="/cookies" element={<Legal type="cookies" />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                    <CookieBanner />
                </BrowserRouter>
                <Toaster
                    position="top-right"
                    theme="dark"
                    toastOptions={{
                        style: {
                            background: "#0a0a0a",
                            border: "1px solid rgba(255,255,255,0.08)",
                            color: "#fff",
                        },
                    }}
                />
            </I18nProvider>
        </div>
    );
}

export default App;
